export default "__VITE_ASSET__C_HzBv7v__"